import React from 'react';
import type { CSSProp } from 'styled-components';

import { SkeletonLabel } from './SkeletonLabel';
import * as styles from './SkeletonCard.styles';

export interface SkeletonCardProps {
  className?: string;
  cropImageForMobile?: boolean;
  imageStyle?: CSSProp;
  productIndex?: number;
}

export const SkeletonCard = ({
  className,
  cropImageForMobile = true,
  imageStyle,
  productIndex,
}: SkeletonCardProps) => (
  <section className={className} css={styles.card} data-testid="skeleton-card">
    <div
      css={[
        styles.imagePlaceholder,
        cropImageForMobile &&
          productIndex &&
          (productIndex % 2 === 0 ? styles.mobileImageCropOdd : styles.mobileImageCropEven),
        imageStyle,
      ]}
    />
    <div css={styles.copy}>
      <div css={styles.mainSection}>
        <SkeletonLabel css={styles.labelMargin} labelHeight="MD" />
        <SkeletonLabel css={styles.labelMargin} labelHeight="MD" />
      </div>
      <SkeletonLabel labelHeight="MD" variant="short" />
    </div>
  </section>
);
